import { render, staticRenderFns } from "./BaseRawData.vue?vue&type=template&id=0c561af0&scoped=true&"
import script from "./BaseRawData.vue?vue&type=script&lang=js&"
export * from "./BaseRawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c561af0",
  null
  
)

export default component.exports